export const envs = [
    {
        name: 'CLAIM',
        siteTitle: 'Claim Fasttoken',
    },
    {
        name: 'PRIVATE_SALE_1',
        siteTitle: 'FUTURE TOKEN PURCHASE ORDER',
    },
    {
        name: 'PRIVATE_SALE_2',
        siteTitle: 'FUTURE TOKEN PURCHASE ORDER',
    },
    {
        name: 'ADVISORS',
        siteTitle: 'SOFTCONSTRUCT EMPLOYEE REWARDS',
    },
    {
        name: 'ALLOCATIONS',
        siteTitle: 'FTN DISTRIBUTION',
    },
];

export const currentEnv = envs.find((env) => process.env.REACT_APP_MODE === env.name);
